import React, {Component} from 'react';
import {connect} from "react-redux";
import {Link, withRouter} from "react-router-dom";
import {downloadTranslations, getLanguages} from "../../redux/actions";
import {
    Button, ButtonGroup, ButtonToolbar, Grid, Row, Table
} from "react-bootstrap";

import {authorised} from "../layout/authorised";

class LanguageOverview extends Component {
    constructor(props) {
        super(props);
        props.dispatch(getLanguages());
    }

    newLanguage(e) {
        this.props.history.push('/i18n/create')
    }

    onEdit(language, event) {
        event.preventDefault();
        this.props.history.push('/i18n/'+language.id)
    }

    customerForId(id) {
        return this.props.customers.find(c => c.id === id);
    }

    downloadJson(e, lang) {
        e.preventDefault();
        e.stopPropagation();
        this.download(lang, "json", true)
    }

    downloadYaml(e, lang) {
        e.preventDefault();
        e.stopPropagation();
        this.download(lang, "yml", false)
    }

    /**
     * @param language  object      the language object
     * @param format    string      'json' or 'yml'
     * @param flat      bool        Should the translation file have flat keys (true), or nested keys (false)?
     */
    download(language, format = "json", flat = false) {
        this.props.dispatch(downloadTranslations(language.id, format, flat));
    }

    render() {
        return (
                <Grid>
                    <Row>
                        <h2>Translations</h2>
                        <p><Link to='/i18n/editor'>Open</Link> dynamic viewer</p>
                        {/*Buttons to trigger table columns*/}
                        <ButtonToolbar>
                            <ButtonGroup>
                            </ButtonGroup>
                        </ButtonToolbar>
                        <Table striped bordered condensed hover>
                            <thead>
                            <tr>
                                <th>Language</th>
                                <th>Master</th>
                                <th>Base</th>
                                <th>Customer</th>
                                <th>
                                    # of translations
                                    <Button onClick={e => this.newLanguage(e)} id="add-language">
                                        <i className="fas fa-plus"/>
                                    </Button>
                                </th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.props.languages && this.props.languages.map(lang =>
                                <tr key={lang.id}>
                                    <td><a onClick={e => this.onEdit(lang, e)}>{lang.languageCode}</a></td>
                                    <td>{lang.master ? "yes" : "no"}</td>
                                    <td>{lang.base ? "yes" : "no"}</td>
                                    <td>{lang.customerId ? this.customerForId(lang.customerId).name : "-"}</td>
                                    <td>{Object.keys(lang.translations).length}</td>

                                    <td>
                                        <span onClick={(e) => this.downloadJson(e, lang)}>
                                            <i style={{fontSize: "22px", marginRight: "5px"}} className="fab fa-js" />
                                        </span>
                                        <span  onClick={(e) => this.downloadYaml(e, lang)}>
                                            <i style={{fontSize: "22px", marginRight: "5px"}} className="fab fa-php"/>
                                        </span>
                                    </td>
                                </tr>
                            )}
                            </tbody>
                        </Table>
                    </Row>
                </Grid>
        );
    }
}

const mapStateToProps = state => {
    return {loggedIn: state.loggedIn, languages: state.languages, customers: state.customers};
};

const mapDispatchToProps = (dispatch) => ({dispatch});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(authorised(LanguageOverview)));



// WEBPACK FOOTER //
// ./src/components/languages/LanguageOverview.js